class AvailableTierPayload {
  constructor(id) {
    this.tier_id = id;
  }
}

export default AvailableTierPayload;
